import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './components/_globals'
import BaiduMap from 'vue-baidu-map'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less';
import moment from 'moment';
import 'moment/locale/zh-cn';
import './xx-vue/network/http_config'
import scroll from 'vue-seamless-scroll'
import VueMeta from 'vue-meta'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
Vue.use(scroll)

Vue.use(VueMeta)

moment.locale('zh-cn');

Vue.config.productionTip = false
Vue.use(BaiduMap, { ak: 'C0HaYkufEtTcAcSAkhGQufRAVwjTeCYL' })
Vue.use(Antd)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
